
import StyledButtonNewItem from './styledButtonNewItem'
import AddIcon from 'material-ui/svg-icons/content/add'
import ButtonIcon from 'components/button-icon'

const ButtonNewItem = props => (
  <StyledButtonNewItem>
    <ButtonIcon
      buttonType="default"
      buttonIcon={<AddIcon style={{ width: 39, height: 39 }} color='var(--color-brand-500)' />}
      className="button-new-item"
      style={{ width: "40px", height: "40px" }}
      {...props}
    />
  </StyledButtonNewItem>
)

export default ButtonNewItem
